import React from "react";
import Tooltip from "../tooltip/Tooltip";
import Footnote from "../footnote/Footnote";
import { useTooltipFootnoteStore } from "../../../stores/use-tooltip-footnote-store";
import { EditorContainer } from "./styles";

function TooltipFootnoteEditor() {
  const { data } = useTooltipFootnoteStore();

  return (
    <EditorContainer>
      {data.macroType === "tooltip" && (
        <Tooltip
          description={data.description}
          color={data.color}
          textColor={data.textColor}
        />
      )}
      {data.macroType === "footnote" && (
        <Footnote description={data.description} color={data.color} />
      )}
    </EditorContainer>
  );
}

export default TooltipFootnoteEditor;
